<template>
    <v-container fluid fill-height>
      <v-layout class="main-search">
        <v-flex>
        </v-flex>
      </v-layout>
       <v-layout class="config-menu" style="vertical-align:baseline !important;">
        <v-flex>
            <configMenu />
        </v-flex>
       </v-layout>
    </v-container>

</template>


/--------------------------------------------------
<script>
import configMenu from "@/components/portal/layout/ConfigMenu";


export default {
  components: {
    configMenu
  }
};
</script>


<style lang="scss">
.main-search{
  height: 100%;
  width: calc(100% - var(--sidebar-width + 150));
}
.main-search .icon-busca{
  margin:0 0 0 var(--gutter);
}
.header-avatar{
  max-width: 60px;
  max-height: 60px;
  width: calc(var(--header-height)/2);
  height: calc(var(--header-height)/2);
  border-radius: 50%;
  background-color:#000;;
  flex:none;
}
.avatar{
  width: 60px;
  height: 100%;
}
.header-icon{
  margin: 0 var(--gutter) 0 0;
  flex: none;
}
.header-icon.flex{
  flex: none;
}
.header-search-field{
  font-family: 'Conduit ITC Extra Light';
}
.header-search-field input{
  font-size: 20px; 
}
.config-menu{
  width: var(--sidebar-width + 150);
  height: 100%;
  padding: 0 0 0 var(--gutter);
  flex: none;
}
.main-logo{
    height:var(--header-height);
    background-color: var(--white);
    flex: none;
  }
</style>
